/**
 * Query param used to carry the QR payload in a shareable link.
 */
export const QR_SHARE_PARAM = "text";

/**
 * Build a shareable link for the given QR payload by setting/replacing the
 * `text` query param on the provided base URL. Returns `null` when the payload
 * is empty (after trimming) or the base URL cannot be parsed.
 */
export function buildShareLink(baseHref: string, text: string): string | null {
  const value = text.trim();
  if (!value) {
    return null;
  }
  try {
    const url = new URL(baseHref);
    url.searchParams.set(QR_SHARE_PARAM, value);
    return url.toString();
  } catch {
    return null;
  }
}

/**
 * Extract the shared QR payload from a URL query string (e.g.
 * `window.location.search`). Returns the trimmed value, or `null` when the
 * param is absent or blank.
 */
export function parseSharedText(search: string): string | null {
  const raw = new URLSearchParams(search).get(QR_SHARE_PARAM);
  if (raw == null) {
    return null;
  }
  const value = raw.trim();
  return value ? value : null;
}
